import { useConvexQuery } from "@/hooks/use-convex-query"
import { MANUAL_GOOGLE_REVIEWS } from "@/lib/manual-reviews"
import { api } from "../../convex/_generated/api"

export type GoogleReviews = {
  /** Average rating on Google's 1-5 scale, e.g. 4.9. */
  rating: number
  /** Total number of Google reviews. */
  userRatingCount: number
  /** When the data was fetched (epoch ms). */
  fetchedAt: number
}

/**
 * Returns the Google rating + review count.
 *
 * Source priority:
 *   1. Live value from the Google Places API, cached in Convex (once an API key
 *      is configured and the cron has run).
 *   2. A manually-maintained real value (see `MANUAL_GOOGLE_REVIEWS`) — used
 *      while there is no API key.
 *
 * Returns `null` only when neither source has a value, in which case components
 * render nothing rather than a fabricated rating.
 */
export function useGoogleReviews(): GoogleReviews | null {
  const data = useConvexQuery(api.googleReviews.get, {}) as
    | GoogleReviews
    | null
    | undefined
  return data ?? MANUAL_GOOGLE_REVIEWS
}
